import axios from "../../axios";

const urlBranch = "/master/rooms";

const state = {
  rooms: [],
};

const actions = {
  /**
   * Get all rooms
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  // async getAllRooms ({ commit }, query) {
  //   try {
  //     const response = await axios.get(`${urlBranch}?${new URLSearchParams(query)}`)
  //     if (response.status === 200) {
  //       commit('SET_ALL_ROOMS', response.data.data)
  //     }
  //   } catch (e) {
  //     console.log('exception: ', e)
  //   }
  // },
  async getAllRooms({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlBranch}`, { params: param })
        .then((response) => {
          commit("SET_ALL_ROOMS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  resetRooms({ commit }, data) {
    commit("SET_ALL_ROOMS", data);
  },
};

const mutations = {
  SET_ALL_ROOMS(state, data) {
    state.rooms = data?.items || [];
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
